import type { ComponentProps } from 'react'

/** Generated from Penpot `icons / exclamation in circle`. Do not edit by hand. */
export function ExclamationCircleIcon(props: ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M20,10C20,15.52,15.52,20,10,20C4.48,20,0,15.52,0,10C0,4.48,4.48,0,10,0C15.52,0,20,4.48,20,10M10,12.02C8.98,12.02,8.15,12.85,8.15,13.87C8.15,14.89,8.98,15.73,10,15.73C11.02,15.73,11.85,14.89,11.85,13.87C11.85,12.85,11.02,12.02,10,12.02M8.24,5.35L8.54,10.83C8.55,11.09,8.76,11.29,9.02,11.29L10.98,11.29C11.24,11.29,11.45,11.09,11.46,10.83L11.76,5.35C11.78,5.07,11.56,4.84,11.28,4.84L8.72,4.84C8.44,4.84,8.22,5.07,8.24,5.35" />
    </svg>
  )
}
